<script>
  /* global DEBUG, SSR */
  import { setup as setupMediaQueries } from "svelte-match-media";
  import Controls from "@components/Controls";
  import ErrorNotification from "@components/ErrorNotification";
  import Info from "@components/Info";
  import Media from "@components/Media";
  import StateDebugger from "@components/StateDebugger";
  import Title from "@components/Title";
  import { setupI18n } from "@services/i18n";
  import createStores from "@stores";
  import { conversation, dwell } from "@stores/videos";
  import { browser, supportsEnhancedExperience } from "@utils/support";
  import { setTheme } from "./theme";

  // Standard props
  export let nluSessionId;
  export let experience;
  export let features;
  export let response;

  // SSR-only props
  export let ssrHasSeenIntro = false;

  export let showDebugger = (DEBUG && !SSR) || false;

  setupI18n(experience.language);

  // Prevent POST on refresh/back button if SSR-only
  if (ssrHasSeenIntro && browser) {
    window.history.replaceState(null, null, window.location.href);
  }

  if (supportsEnhancedExperience) {
    setTheme(experience.theme);
  }

  setupMediaQueries({
    desktop: "screen and (min-width: 769px)",
    mobile: "screen and (max-width: 768px)"
  });

  createStores({
    nluSessionId,
    experience,
    features,
    introSeen: ssrHasSeenIntro,
    response
  });

  const {info} = experience;

  let transcript;

  if (response && response.payload) {
    transcript = response.payload.transcript;
  }
</script>

<style>
  main {
    margin: 5vh auto;
    max-width: 60vw;
  }

  :global(.enhanced) main {
    height: 100%;
    left: 0;
    margin: 0;
    max-width: 100%;
    position: absolute;
    top: 0;
    width: 100%;
  }
</style>

{#if showDebugger}
  <StateDebugger />
{/if}

<main>
  {#if !supportsEnhancedExperience}
    <Title title={experience.title} />
    {#if info}
      <Info {info} />
    {/if}
  {/if}

  <Media
    conversation={$conversation}
    dwell={$dwell}
    poster={experience.poster}
    {transcript}
    title={experience.title}
  />

  <ErrorNotification />

  <Controls />
</main>
